module.exports = __webpack_public_path__ + "static/media/Nesivos.b3465f64.jpg";